<template>
  <div class="orderdetails">
    <!-- 面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/myorder' }">我的订单</el-breadcrumb-item>
      <el-breadcrumb-item>订单详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 详情 -->
    <el-card class="main" style="margin-top:20px">
      <div slot="header" class="clearfix">
        <div>
          <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
          <b>基本详情</b>
        </div>
        <el-button-group>
          <!-- <el-button type="primary" @click="getMaitou" icon="el-icon-download">唛头</el-button> -->
          <el-button type="success" icon="el-icon-download" @click="getMaitou" >下载唛头</el-button>
          <el-button type="primary" @click="getRucangdan" icon="el-icon-download">入仓单</el-button>
        </el-button-group>
      </div>
      <!-- 基本信息 -->
      <el-table :data="messageData" style="width: 100%">
        <el-table-column prop="clientNo" label="运单号"></el-table-column>
        <el-table-column prop="channelName" label="渠道名称"></el-table-column>
        <el-table-column prop="dispatchPlace" label="送货仓 "></el-table-column>
        <el-table-column prop="ctn" label="件数 "></el-table-column>
        <el-table-column prop="declareType" label="报关"></el-table-column>
        <el-table-column prop="insurance" label="保险"></el-table-column>
        <el-table-column prop="insuranceFee" label="保险额USD"></el-table-column>
        <el-table-column label="下单时间">
          <template slot-scope="scope">
            <span>
              {{
              scope.row.createTime | dateformat
              }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="messageData" style="width: 100%">
        <el-table-column prop="enLogno" label="派送单号 "></el-table-column>
        <el-table-column prop="freightMethod" label="业务类型"></el-table-column>
        <el-table-column prop="pickupType" label="取件方式"></el-table-column>
        <el-table-column prop="dispatchPlace" label="送货仓 "></el-table-column>
<!--        <el-table-column prop="sellerName" label="业务员 "></el-table-column>-->
        <el-table-column prop="dispatchTime" label="送货时间">
          <template slot-scope="scope">
            <span>
              {{ scope.row.dispatchTime | dateformat }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="orderStatus" label="订单状态"></el-table-column>
        <el-table-column prop="recStatus" label="付款状态"></el-table-column>
        <el-table-column prop="userRemark" label="备注"></el-table-column>
      </el-table>
      <el-table :data="messageData" style="width: 100%">
        <el-table-column prop="impor" label="进口商"></el-table-column>
        <el-table-column prop="shipper" label="发货人"></el-table-column>
        <el-table-column prop="address" label="详细地址"></el-table-column>

      </el-table>
    </el-card>
    <!-- 柜子or进度 -->
    <div style="overflow: hidden">
      <!-- 柜子信息 -->
      <el-card class="main" style="margin-top:20px;width: 49%;float:left">
        <div slot="header" class="clearfix">
          <div>
            <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
            <b>柜子信息</b>
          </div>
        </div>
        <ul class="container">
          <!-- <li>
            <div class="lableTitle">
              <b>船公司:</b>
            </div>
            <span>{{this.container.shipCompany}}</span>
          </li>
          <li>
            <div class="lableTitle">
              <b>船名航次:</b>
            </div>
            <span>{{this.container.shipNo}}</span>
          </li> -->
          <li>
            <div class="lableTitle">
              <b>开船日:</b>
            </div>
            <span>{{ container.etd ? $options.filters.dateformat(container.etd) : '未开放' }}</span>
          </li>
          <li>
            <div class="lableTitle">
              <b>到港日:</b>
            </div>
            <span>{{ container.etd ? $options.filters.dateformat(container.eta) : '未开放' }}</span>
          </li>
          <li>
            <div class="lableTitle">
              <b>起运港:</b>
            </div>
            <span>{{ container.etd ? container.pol : '未开放' }}</span>
          </li>
          <li>
            <div class="lableTitle">
              <b>目的港:</b>
            </div>
            <span>{{ container.etd ? container.podEnd : '未开放' }}</span>
          </li>
        </ul>
      </el-card>
      <!-- 操作进度 -->
      <el-card class="main" style="margin-top:20px;width: 49%;float:right;height:158px">
        <div slot="header" class="clearfix">
          <div>
            <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
            <b>物流进度</b>
          </div>
        </div>
        <el-timeline style="overflow-y: auto;height: 100px;">
          <el-timeline-item
            v-for="(item, index) in schedule"
            :key="index"
            :icon="item.icon"
            :size="item.size"
            :type="item.type"
            :color="item.color"
          >
            <b>{{item.content}}</b>
            <span style="margin-left:15px">{{item.createTime|dateformat}}</span>
          </el-timeline-item>
        </el-timeline>
      </el-card>
    </div>
    <!-- 费用or关税单 -->
  <div style="overflow:hidden">
    <!-- 费用 -->
    <el-card class="main" style="margin-top:20px;width: 49%;float:left">
      <!-- 操作进度 -->
      <div slot="header" class="clearfix">
        <div>
          <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
          <b>费用</b>
        </div>
      </div>
      <el-table :data="moneyData" style="width: 100%">
        <!-- <el-table-column prop="applyNo" label="交易编号"></el-table-column> -->
        <el-table-column prop="feeName" label="费用"></el-table-column>
        <!-- <el-table-column prop="feeNameEn" label="费用英文名"></el-table-column> -->
        <el-table-column label="单价*数量">
          <template slot-scope="scope">
            {{scope.row.price}}*{{scope.row.num}}
          </template>
        </el-table-column>
        <el-table-column label="合计金额">
          <template slot-scope="scope">
            {{scope.row.money}} {{scope.row.currency}}
          </template>
        </el-table-column>
        <el-table-column prop="exchangeRate" label="汇率"></el-table-column>
        <el-table-column label="折合金额">
          <template slot-scope="scope">
            {{scope.row.toMoney}} {{scope.row.toCurrency}}
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column> 
          <!-- <el-table-column label="销帐时间">
          <template slot-scope="scope">
            <span>
              {{scope.row.settleTime | dateformat}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态"></el-table-column> -->


      </el-table>
    </el-card>
    <!-- 关税单 -->
    <el-card class="main" style="margin-top:20px;width: 49%;float:right;">
      <!-- 操作进度 -->
      <div slot="header" class="clearfix">
        <div>
          <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
          <b>文件</b>
        </div>
      </div>
      <el-table :data="guanshuiData">
        <el-table-column prop="name" label="文件名"></el-table-column>
        <el-table-column label="上传时间">
          <template slot-scope="scope">
            {{scope.row.createTime | dateformat}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" width="90">
          <template slot-scope="scope">
            <el-button type="text" @click="downloadWj(scope.row)">下载</el-button>
          </template>
        </el-table-column> -->
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-link :href="scope.row.url" type="primary" target="_blank">下载</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
    <!-- 材积 -->
    <el-card class="main" style="margin-top:20px">
      <div slot="header" class="clearfix">
        <div>
          <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
          <b>材积</b>
        </div>
      </div>
      <el-table :data="volumeData" style="width: 100%" show-summary :summary-method="getSummaries">
        <el-table-column type="index" label="序号" width="150"></el-table-column>
        <el-table-column prop="num" label="总件数CTN"></el-table-column>
        <el-table-column prop="realWeight" label="单箱实重"></el-table-column>
        <el-table-column prop="length" label="长CM"></el-table-column>
        <el-table-column prop="width" label="宽CM"></el-table-column>
        <el-table-column prop="height" label="高CM"></el-table-column>
        <el-table-column prop="weight" label="总实重"></el-table-column>
        <el-table-column prop="volumeWeight" label="体积重KG"></el-table-column>
        <el-table-column prop="volume" label="体积CBM"></el-table-column>
        <!-- <el-table-column prop="weightVolume" label="重量方CBM"></el-table-column> -->
        <el-table-column prop="finalsettle" label="结算重/方"></el-table-column>
      </el-table>
    </el-card>
    <!-- 品牌 -->
    <el-card class="main" style="margin-top:20px">
      <!-- 操作进度 -->
      <div slot="header" class="clearfix">
        <div>
          <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
          <b>产品申报</b>
        </div>
      </div>
      <el-table :data="brandData" style="width: 100%">
        <el-table-column prop="name" label="中文名"></el-table-column>
        <el-table-column prop="ename" label="英文名"></el-table-column>
        <el-table-column prop="hscode" label="税号"></el-table-column>
        <el-table-column prop="material" label="材质"></el-table-column>
        <el-table-column prop="purpose" label="用途"></el-table-column>
        <el-table-column prop="unitValue" label="单价"></el-table-column>
        <el-table-column prop="qty" label="数量"></el-table-column>
        <el-table-column prop="totalValue" label="总价"></el-table-column>
        <el-table-column label="图片">
          <template slot-scope="scope">
            <el-image :src="scope.row.picUrl" style="width:50px"></el-image>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <!-- 取件方式 -->
    <el-card class="main" style="margin-top:20px">
      <div slot="header" class="clearfix">
        <div>
          <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
          <b>取件方式</b>
        </div>
      </div>
      <el-table :data="trailerData" style="width: 100%">
        <el-table-column prop="status" label="提货状态"></el-table-column>
        <!-- <el-table-column prop="cbm" label="预估方数"></el-table-column>
        <el-table-column prop="kg" label="预估重量"></el-table-column>
        <el-table-column prop="ctn" label="件数"></el-table-column>
        <el-table-column label="日期">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | dateformat }}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="driverCarNo" label="司机车牌号"></el-table-column>
        <el-table-column prop="driverName" label="司机"></el-table-column>
        <el-table-column prop="driverTel" label="司机电话"></el-table-column>
        <el-table-column label="提货时间" width="120">
          <template slot-scope="scope">
            <span>
              {{
              scope.row.getsTime | dateformat
              }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="取件时间截至" width="120">
          <template slot-scope="scope">
            <span>
              {{
              scope.row.geteTime | dateformat
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="派车日期">
          <template slot-scope="scope">
            <span>
              {{
              scope.row.sendTime | dateformat
              }}
            </span>
          </template>
        </el-table-column> -->
        <el-table-column prop="contact" label="供应商联系人" width="120"></el-table-column>
        <el-table-column prop="contactTel" label="供应商电话"></el-table-column>
        <el-table-column prop="contactAdd" label="供应商地址"></el-table-column>
        <el-table-column prop="remark" label=" 备注"></el-table-column>
      </el-table>
    </el-card>
    <!-- 预约号 -->
    <el-card class="main" style="margin-top:20px">
      <!-- 操作进度 -->
      <div slot="header" class="clearfix">
        <div>
          <i class="el-icon-bank-card" style="line-height:23px;margin:0 10px"></i>
          <b>预约号</b>
        </div>
      </div>
      <el-table :data="orderShip" style="width: 100%">
        <el-table-column prop="shipmentid" label="亚马逊预约单号"></el-table-column>
        <el-table-column prop="referenceid" label="亚马逊跟踪号"></el-table-column>
        <el-table-column prop="kg" label="重量/KG"></el-table-column>
        <el-table-column prop="ctn" label="件/CTN"></el-table-column>
        <el-table-column prop="cbm" label="体积/CBM"></el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      class="abnormal"
      title="唛头下载"
      :visible.sync="dialogFormVisible3"
      :close-on-click-modal="true"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      width="35%"
    >
      <div class="dialog-footer" style="text-align:center;">
        <el-select v-model="marks" clearable placeholder="请选择唛头模板"  value-key="id">
          <el-option
            v-for="(item,index) in options3"
            :key="index"
            :label="item.marks"
            :value="item"
          ></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="success" @click="getMaitou2()">单张唛头</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//引入api
import httpApi from "@/http/api";
export default {
  data() {
    return {
      messageData: [],
      volumeData: [],
      brandData: [],
      trailerData: [],
      schedule: [],
      container: {
        etd: null,
        eta: null,
        pol: '',
        podEnd: '',},
      orderShip: [],
      options3: [],
      marks: {},
      moneyData: [],
      guanshuiData:[],
      dialogFormVisible3: false,
      finalsettle: "",//结算重
      weight: "",
      volumeWeight: "",
      volume: "",
      settleType: "",
      ctn:""
    };
  },
  methods: {
    //下载唛头
    getMaitou() {
      this.dialogFormVisible3 = true;
      this.init3();
    },
    getMaitou2(type) {
      let typeFlag = type ? "a4" : "";
      this.dialogFormVisible3 = false;
      window.open(
        this.mApi +
          "report/mai_tou3?orderNo=" + this.$route.params.orderNo + "&type=" + typeFlag + "&marksModel=" + this.marks.marksModel +"&suffix="+this.marks.suffix+"&serialNum="+this.marks.serialNum+"&isHasSuffix="+this.marks.isHasSuffix
      );
    },
    init3() {
      let that = this;
      httpApi
        .listParams( {
          params: {
            type: "sys_marks",
            enable:"1"
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.options3 = res.data.data;
          }
        });
    },
    //下载入仓单
    getRucangdan() {
      window.open(
        this.mApi + "report/ru_cang_dan?orderNo=" + this.$route.params.orderNo
      );
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 0) {
        return "warning-row";
      }
      return "";
    },
    init() {
      let that = this;
      httpApi
        .findOrder({
          params: { orderNo: that.$route.params.orderNo }
        })
        .then(res => {
          if (res.data.code == "ok") {
            //基本信息
            that.messageData.push(res.data.data.findOrderResponse);
            //柜子信息
            if (res.data.data.findContainerResponse) {
              that.container = res.data.data.findContainerResponse;
            }
            //材积
            that.volumeData = res.data.data.findOrderVolumeResponseList;
            //操作进度
            that.schedule = res.data.data.findOrderLogisticsResponseList;
            //品牌
            that.brandData = res.data.data.findOrderGoodsResponseList;
            //取件方式
            that.trailerData = res.data.data.findOrderTrailerResponseList;
            //预约号
            that.orderShip = res.data.data.findOrderShipmentResponseList;
            //金额
            that.moneyData = res.data.data.findOrderSettleResponseList;
            //关税
            that.guanshuiData = res.data.data.findOrderFileResponseList;
            //品牌！！！！！
            //品牌类型
            for (let i in that.brandData) {
              if (that.brandData[i].brandType == 0) {
                that.brandData[i].brandType = "无品牌";
              } else if (that.brandData[i].brandType == 1) {
                that.brandData[i].brandType = "境内自主品牌";
              } else if (that.brandData[i].brandType == 2) {
                that.brandData[i].brandType = "境内收购品牌";
              } else if (that.brandData[i].brandType == 3) {
                that.brandData[i].brandType = "境外品牌（贴牌生产）";
              } else {
                that.brandData[i].brandType = "境外品牌（其他）";
              }
            }
            //取件方式!!!!!
            //提货状态
            for (let i in that.trailerData) {
              if (that.trailerData[i].status == 0) {
                that.trailerData[i].status = "待提货";
              } else {
                that.trailerData[i].status = "已提货";
              }
            }
            //结算重
            that.ctn=that.messageData[0].realCtn
            that.finalsettle = that.messageData[0].finalsettle
            that.weight = that.messageData[0].realKg
            that.volumeWeight = that.messageData[0].volumeWeight
            that.volume = that.messageData[0].realCbm
            that.settleType = that.messageData[0].settleTypeTxt
            //详情！！！！！
            //发货人
            let ship = "";
            ship =
              that.messageData[0].shipperName +
              that.messageData[0].shipperAddress;
            that.messageData[0].shipper = ship;
            //收货地址
            let arr = "";
            arr =
              that.messageData[0].shipmentContact +
              that.messageData[0].shipmentCountry +
              that.messageData[0].shipmentState;

            //地址类型判断
            if (that.messageData[0].shipmentType == 0) {
              that.messageData[0].shipmentType = "fba地址";
              that.messageData[0].address = that.messageData[0].shipmentAddress;
            } else {
              that.messageData[0].shipmentType = "私人地址"; //需要拼接
              that.messageData[0].address =
                that.messageData[0].shipmentAddress + arr;
            }
            //报关判断
            if (that.messageData[0].declareType == 0) {
              that.messageData[0].declareType = "买单";
            } else {
              that.messageData[0].declareType = "退税";
            }
            //保险状态判断
            if (that.messageData[0].insurance == 0) {
              that.messageData[0].insurance = "否";
            } else {
              that.messageData[0].insurance = "是";
            }
            //保险状态判断
            if (that.messageData[0].insuranceFee == 0) {
              that.messageData[0].insuranceFee = "";
            }
            //取件方式判断
            if (that.messageData[0].pickupType == 0) {
              that.messageData[0].pickupType = "自送货";
            } else {
              that.messageData[0].pickupType = "上门提货";
            }
            //业务类型判断
            if (that.messageData[0].freightMethod == 0) {
              that.messageData[0].freightMethod = "拼柜";
            } else {
              that.messageData[0].freightMethod = "整柜";
            }
            //进口商类型
            if (that.messageData[0].importerType == 0) {
              that.messageData[0].impor =
                that.messageData[0].importerAddress +
                that.messageData[0].importerName +
                that.messageData[0].importerTel;
            } else {
              that.messageData[0].impor = "代理进口商";
            }
          } else {
            that.$message.error(res.data.message);
          }
          //物流进度
          for (let i in that.schedule) {
            that.schedule[i].color = "";
            that.schedule[i].icon = "";
            that.schedule[i].size = "normal";
            that.schedule[0].color = "red";
            that.schedule[0].icon = "el-icon-success";
            that.schedule[0].size = "large";
          }
        });
    },
    getSummaries(param){
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计';
          return;
        }

        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[1] = this.ctn
          sums[2] = ""
          sums[3] = ""
          sums[4] = ""
          sums[5] = ""
          sums[6] = this.weight
          sums[7] = this.volumeWeight
          sums[8] = this.volume
          sums[9] = this.finalsettle+this.settleType;
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    }
  },
  created() {
    this.init();
  },
  watch: {
    // 方法1 //监听路由是否变化
    $route(to, from) {
      //监听路由是否变化
      if (to.params.orderNo != from.params.orderNo) {
        this.messageData = [];
        this.$route.params.orderNo = to.params.orderNo;
        this.init(); //重新加载数据
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.el-card__header {
  padding: 10px 20px;
}
/deep/.main .el-card__body {
  padding: 0px 20px 20px;
}
/deep/.main .el-card__header {
  background-color: #ebeef5;
}
.mesCard {
  margin: 20px;
  margin-top: 30px;
}
.clearfix {
  text-align: left;
  margin-left: -10px;
  display: flex;
  line-height: 35px;
  height: 35px;
  .el-input {
    width: 150px !important;
  }
  span,
  button {
    margin-left: 20px;
  }
  i,
  b {
    font-size: 13px;
  }
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #fff;
}
/deep/.schTable .el-table__header {
  display: none;
}
/deep/.el-table th > .cell {
  color: black;
}
/deep/.container {
  margin-top: 10px;
  overflow: hidden;
  li {
    padding: 10px 0;
    width: 50%;
    float: left;
    .lableTitle {
      display: inline-block;
      width: 60px;
    }
  }
}
/deep/.el-table .warning-row {
  color: red;
}
/deep/.el-timeline {
  margin-top: 20px;
  li:first-child .el-timeline-item__wrapper .el-timeline-item__content {
    color: red;
  }
  .el-timeline-item__tail {
    left: 7px;
  }
  .el-timeline-item__node--large {
    left: 1px;
  }
  .el-timeline-item__node--normal {
    left: 2px;
  }
}
</style>